import { render } from "./DriverAdmin.vue?vue&type=template&id=0b5d7ff1"
import script from "./DriverAdmin.vue?vue&type=script&lang=js"
export * from "./DriverAdmin.vue?vue&type=script&lang=js"
script.render = render

export default script